import ChartClient from './ChartClient';
import HttpClient from '../../gateway/HttpClient';
import HttpMethod from '../../constant/HttpMethod';
import { ChartMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import MessageUtil from 'util/MessageUtil';
import { ChartJsonModel, ChartResponse } from '../../domain/chart/ChartDomains';
import Query = query.Query;
import { CaseChartPanel } from '../../domain/case/CaseDomains';
import { ChartSchema } from '../../../../server/src/lib/domain/chart/ChartDomain';
import LanguageUtil from '../../util/LanguageUtil';

class NestChartClient implements ChartClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public async simulateCharForCase(chartId: string, panel: CaseChartPanel, transactionValue: string): Promise<ChartResponse> {
    const dto = {
      chartId: chartId,
      panelField: panel,
      transactionValue: transactionValue,
    };
    return await this.httpClient.execute(HttpMethod.POST, `${ChartMethods.SIMULATE_FOR_CASE}`, dto);
  }

  public async save(dto: ChartJsonModel) {
    try {
      const saveDto = {
        chart: dto,
      };
      return await this.httpClient.execute(HttpMethod.POST, `${ChartMethods.SAVE}`, saveDto);
    } catch (e) {
      MessageUtil.warning({
        summary: LanguageUtil.get({ id: 'messages.warning.chartSaved', defaultMessage: 'Chart Saved Failed' }),
        detail: LanguageUtil.get({ id: 'messages.warning.dtoSavedFailed', defaultMessage: `${dto.name} saved failed` }, { 0: `${dto.name}` }),
      });
      console.log(e);
    }
  }

  public async getChartById(id: string): Promise<ChartJsonModel> {
    return await this.httpClient.execute(HttpMethod.GET, `${ChartMethods.GET_BY_ID}/${id}`);
  }

  public async getChartSchemaById(id: string): Promise<ChartSchema> {
    return await this.httpClient.execute(HttpMethod.GET, `${ChartMethods.GET_SCHEMA_BY_ID}/${id}`);
  }

  public async simulate(dto: ChartJsonModel): Promise<any> {
    return await this.httpClient.execute(HttpMethod.POST, `${ChartMethods.SIMULATE}`, dto);
  }

  public async execute(chartId: string): Promise<any> {
    return await this.httpClient.execute(HttpMethod.POST, `${ChartMethods.EXECUTE}/${chartId}`);
  }

  public async remove(id: string) {
    return await this.httpClient.execute(HttpMethod.DELETE, `${ChartMethods.REMOVE}/${id}`);
  }

  public async deploy(id: string) {
    return await this.httpClient.execute(HttpMethod.POST, `${ChartMethods.DEPLOY}/${id}`);
  }

  public async undeploy(id: string) {
    return await this.httpClient.execute(HttpMethod.POST, `${ChartMethods.UNDEPLOY}/${id}`);
  }

  public async exist(id: string): Promise<boolean> {
    return await this.httpClient.execute(HttpMethod.POST, `${ChartMethods.EXIST}/${id}`);
  }

  public async count(query: Query): Promise<number> {
    return await this.httpClient.execute(HttpMethod.POST, `${ChartMethods.COUNT}`, query);
  }
}

export default NestChartClient;
